/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SklikInputs */

const cs_enum_sklik = /** @type {(inputs: Enum_SklikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik`)
};

const en_enum_sklik = /** @type {(inputs: Enum_SklikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik`)
};

/**
* | output |
* | --- |
* | "Sklik" |
*
* @param {Enum_SklikInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sklik = /** @type {((inputs?: Enum_SklikInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SklikInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sklik(inputs)
	return cs_enum_sklik(inputs)
});